import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";
import REInfoFamilyDocBloc from "../../blocs/retirement/info-perso/REInfoFamilyDocBloc";


export default function REInfoFamilyDocPage() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
    
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Justificatif de situation familiale</h1>
       
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop">
            <REInfoFamilyDocBloc />
            
        </div>
        
      </div>
   
    )

}